import cx from 'classnames';

interface Props {
  name: string;
  value: React.ReactNode;
}

export const OrderTotalsSummaryItem = ({ name, value }: Props) => {
  return (
    <div className={cx('flex justify-between py-3 first:pt-0')}>
      <dt className="text-neutral-40">{name}:</dt>
      <dd className="flex items-center text-neutral-20">{value}</dd>
    </div>
  );
};
